<script>
import { Cell, Col, Row, Image, Empty, Tag, IndexBar, IndexAnchor } from 'vant'
import ObjectFunc from '@/tbs/util/ObjectFunc'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'organization-staff-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-row': Row,
        'van-col': Col,
        'van-image': Image,
        'van-empty': Empty,
        'van-tag': Tag,
        'van-index-bar': IndexBar,
        'van-index-anchor': IndexAnchor,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        memberList: Array,
        memberEmptyHint: String,
        memberInviteLabel: String,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['click-member', 'create-member', 'invite-member', 'shift-member'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        isMemberListEmtpy() {
            return this.memberList && ((this.memberList.length == 0) || ObjectFunc.isEmpty(this.memberList))
        },
        indexList() {
            if (!this.memberList) {
                return []
            }
            const letters = this.memberList.map(member => member.firstLetter)
            const uniqueLetters = [...new Set(letters)]
            uniqueLetters.sort()
            // console.log('@uniqueLetters', uniqueLetters)
            return uniqueLetters
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onMemberItemClick(item) {
            this.$emit('click-member', item)
        },
        onMemberEmptyHintClick() {
            this.$emit('create-member')
        },
        onInviteTagClick(item) {
            this.$emit('invite-member', item)
        },
        onShiftTagClick(item) {
            this.$emit('shift-member', item)
        },
        memberIndexedList(index) {
            return this.memberList.filter(member => member.firstLetter === index).sort(function(a, b) {
                return a.name.localeCompare(b.name)
            })
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <!-- component -->
    <div class="organization-member-list">
        <div v-if="!isMemberListEmtpy">
            <van-index-bar :index-list="indexList">
                <van-index-anchor 
                    v-for="index in indexList" 
                    :key="index" 
                    :index="index"
                >
                    <van-cell 
                        v-for="item in memberIndexedList(index)" 
                        :key="item.id" 
                        center
                        is-link
                        @click="onMemberItemClick(item)"
                    >
                        <template #title>
                            <van-row>
                                <van-col>
                                    <van-image
                                        v-if="item.avatarUrl"
                                        :src="adjustImageSize(item.avatarUrl, 100, 100)"
                                        fit="cover"
                                        width="50px"
                                        height="50px"
                                    />
                                    <img
                                        v-else
                                        src="@/assets/org/logo-symbol.png" 
                                        style="width: 50px; height: 50px;"
                                    />
                                </van-col>
                                <van-col class="l-outer-margin">
                                    <div>
                                        <span>{{ item.name }}</span>
                                        <span 
                                            v-if="item.shiftTag" 
                                            class="shift-tag"
                                            @click.stop="onShiftTagClick(item)">
                                            <van-tag round plain>{{ item.shiftTag }}</van-tag>
                                        </span>
                                    </div>
                                    <div class="lhr">
                                        <span v-if="item.tag"><van-tag>{{ item.tag }}</van-tag></span>
                                        <span v-if="item.description" class="minor-text minor-color">{{ item.description }}</span>
                                        <span 
                                            v-if="!item.isInvited" 
                                            class="invite-tag"
                                            @click.stop="onInviteTagClick(item)">
                                            <van-tag round plain>{{ memberInviteLabel }}</van-tag>
                                        </span>
                                    </div>
                                </van-col>
                            </van-row>
                            <div class="separator-line-bottom"/>
                        </template>
                    </van-cell>
                </van-index-anchor>
            </van-index-bar>
        </div>
        <div v-else @click="onMemberEmptyHintClick">
            <van-empty 
                :description="memberEmptyHint"
                image="search"
            />
        </div>
    </div>
</template>

<style>
.organization-member-list .van-index-anchor {
    padding: 0;
}
.shift-tag,
.invite-tag {
    position: absolute;
    right: 32px;
}
</style>